import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import GetInsuranceProviderDisplayName from '../../../../../../components/data-driven-logo/get-insurance-provider-display-name';
import FormattedCurrency from '../../../../../../components/formatted-currency/container';
import useInsuranceProvider from '../../hooks/use-insurance-provider';
import style from './style.module.less';

const FundingAmountIconToolTip = ({ insuranceProviderId }) => {
  const insuranceProvider = useInsuranceProvider(insuranceProviderId);

  return (
    <Tooltip>
      <div className={style.icon}>
        <FontAwesomeIcon className={style['info-icon']} icon={faInfoCircle} />
      </div>
      <TooltipContent>
        <FormattedMessage
          defaultMessage='{insuranceProviderName} requires a minimum funding amount of {currency}'
          description='Add funds modal minimum funding tooltip'
          id='Qy4231'
          values={{
            insuranceProviderName: <FormattedMessage {...GetInsuranceProviderDisplayName(insuranceProviderId)} />,
            currency: (
              <FormattedCurrency
                currencyCode={insuranceProvider?.minimumFundingAmount?.code}
                value={insuranceProvider?.minimumFundingAmount?.value}
              />
            ),
          }}
        />
      </TooltipContent>
    </Tooltip>
  );
};

FundingAmountIconToolTip.propTypes = {
  insuranceProviderId: PropTypes.string.isRequired,
};
export default FundingAmountIconToolTip;
